import script from "./pinned-report-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./pinned-report-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__